import { InjectionToken } from '@angular/core';

export const BASE_LOCALE_ID = new InjectionToken<boolean>('APP_LOCALE');
